import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import styles from '../../theme/styles';

// Copy shown for each reason the session can end. Keyed by the
// sessionExpiredState atom value ('hold' | 'idle').
const COPY = {
  hold: {
    heading: 'Your appointment hold has expired',
    body: 'We released the time slot we were holding for you. For your privacy, the information you entered was not saved. Please start over to choose a new time.',
  },
  idle: {
    heading: 'Your session has expired',
    body: 'Your session timed out after a period of inactivity. For your privacy, the information you entered was not saved. Please start over.',
  },
};

const SessionExpired = (props) => {
  const { classes, reason } = props;
  const headingRef = useRef(null);
  const copy = COPY[reason] || COPY.idle;

  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  const handleStartOver = () => {
    location.reload();
  };

  return (
    // Focus moves to the heading on mount, so screen readers announce it;
    // no role="alert" here, otherwise it would be announced a second time.
    <div className={classes.sessionExpiredContainer}>
      <Typography
        variant="h2"
        component="h1"
        data-focus-owner="session-expired"
        tabIndex={-1}
        ref={headingRef}
      >
        {copy.heading}
      </Typography>
      <Typography>{copy.body}</Typography>
      <Button
        onClick={handleStartOver}
        color="primary"
        variant="contained"
      >
        Start over
      </Button>
    </div>
  );
};

SessionExpired.propTypes = {
  classes: PropTypes.object.isRequired,
  reason: PropTypes.oneOf(['hold', 'idle']),
};

export default withStyles(styles)(SessionExpired);
